
export const SET_SELECTED_FILE = "SET_SELECTED_FILE";
export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";
export const SET_UPLOAD_RESPONSE = "SET_UPLOAD_RESPONSE";